import React from 'react';

import Typography from 'components/typography/typography';

import { CompanyInsuranceUrl } from 'constants/signup-flow-constants';

const InsuranceInstructions: React.FC = () => {
  return (
    <div className="w-full flex flex-col">
      <Typography as="p" variant="body-medium" className="text-gray600">
        Voor het werken als zelfstandige in de kinderopvang is een
        bedrijfsaansprakelijkheidsverzekering nodig. Zo weet je dat je altijd
        gedekt bent voor schade aan materiaal en letsel bij kinderen tijdens het
        uitvoeren van je werkzaamheden bij kinderopvangorganisaties. En jij goed
        verzekerd bent, mocht er per ongeluk toch iets gebeuren.
        <br />
        <br />
        Je bent vrij om zelf een bedrijfsaansprakelijkheidsverzekering te
        kiezen. Er bestaan ook collectieve verzekeringen voor zelfstandigen in
        de kinderopvang. De bedrijfsaansprakelijkheidsverzekering moet geschikt
        zijn voor werkzaamheden in de kinderopvang als zelfstandige. Dit
        controleert het adviesteam.
        <br />
        <br />
        Als bewijs dat je verzekerd bent, vragen we je om een pdf of scan van
        het voorblad van je polis up te loaden.
        <br />
        <br />
        <b>Heb jij nog geen verzekering?</b>
        <br />
        Heb jij nog geen bedrijfsaansprakelijkheidsverzekering? Je kan in dat
        geval zelf een verzekeraar kiezen of{' '}
        <a href={CompanyInsuranceUrl} className="font-bold">
          klik hier{' '}
        </a>
        voor een aanbod, speciaal voor zelfstandigen in de kinderopvang.
        <br />
        <br />
        Je moet dan later wel alsnog het voorblad van je polis uploaden via mijn
        Tadaah. Anders kan je niet aan de slag als freelancer in de
        kinderopvang.
      </Typography>
    </div>
  );
};

export default InsuranceInstructions;
